import dashboard from '../dashboard/routes';
import employee from '../employee/routes';
import roles from '../roles/routes';
import timeAndAttendance from '../timeAndAttendance/routes';
import user from '../user/routes';
import leaveCategory from '../leaveCategory/routes';
import leaveManagement from '../leaveManagement/routes';
import employeeLeaveManagement from '../leaveAndHolidays/routes';
import managerialTree from '../managerialTree/routes';
import holiday from 'holidays/routes';
import kpiGoal from '../kpi/goal/routes';
import { kpiTemplateRoutes } from '../kpi/template';
import { kpiPeriodRoutes } from '../kpi/period';
import { kpiUserKpiRoutes } from '../kpi/userKpi/routes';
import kpiDashboardRoutes from '../kpi/dashboard/routes';
import menu from '../menu/routes';
import clientManagement from '../clientManagement/routes';
import teamManagement from '../teamManagement/routes';
import profileChangeRequests from '../profileChangeRequests/routes';
import activityLog from '../activityLog/routes';

export default {
    ...dashboard,
    ...employee,
    ...timeAndAttendance,
    ...user,
    ...roles,
    ...leaveCategory,
    ...leaveManagement,
    ...employeeLeaveManagement,
    ...holiday,
    ...managerialTree,
    ...kpiGoal,
    ...kpiTemplateRoutes,
    ...kpiPeriodRoutes,
    ...kpiUserKpiRoutes,
    ...kpiDashboardRoutes,
    ...menu,
    ...clientManagement,
    ...teamManagement,
    ...profileChangeRequests,
    ...activityLog
};
